import { statusDisplayNameForTrackings } from '@rsos/constants/alertStatuses';
import { gspx } from '@rsos/gainsight';

export const trackAlertChatButtonClick = ({
  buttonText,
  isSupplemental = false,
  selectedAlertID,
  irpVersion,
}) => {
  if (isSupplemental) {
    gspx.trackCustomEvent('Alert', {
      irpVersion,
      name: `Click Send Data in RSP for supplemental alert`,
      Category: 'Alert',
      'Launched date': new Date(),
      AlertID: selectedAlertID,
    });
  } else {
    let displayStatus = statusDisplayNameForTrackings[buttonText];

    // TODO: To confirm if one of the custom events can be removed.
    gspx.trackCustomEvent('Alert', {
      irpVersion,
      name: `Click ${displayStatus} button in RSP`,
      Category: 'Alert',
      'Launched date': new Date(),
      AlertID: selectedAlertID,
    });

    gspx.trackCustomEvent('Alert', {
      irpVersion,
      name: `Click ${displayStatus} button in RSP at ${new Date()}`,
      Category: 'Alert',
      'Launched date': new Date(),
      AlertID: selectedAlertID,
    });
  }
};
